"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            var GutterPaneLink = /** @class */ (function (_super) {
                __extends(GutterPaneLink, _super);
                function GutterPaneLink() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.linkKeyDown = function (event) {
                        if ($dyn.util.isShortcutKeyPressed(event.nativeEvent, { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] })) {
                            _this._setSelectedGutterItem(event.nativeEvent);
                        }
                        else {
                            _this.keyHandler(event);
                        }
                    };
                    _this.onClick = function (event) {
                        if (event && event.target && event.type === "click") {
                            _this._setSelectedGutterItem(event.nativeEvent);
                        }
                    };
                    return _this;
                }
                GutterPaneLink.prototype.componentDidMount = function () {
                    this.element.dynContext = { current: this };
                };
                GutterPaneLink.prototype.componentDidUpdate = function () {
                    this.element.dynContext = { current: this };
                };
                GutterPaneLink.prototype.render = function () {
                    var _this = this;
                    var classes = "gutterPane-link";
                    var imageContent = UI.GutterUtil.buildImageLink({ Image: this.props.Image, ImageType: this.props.ImageType, Label: this.props.Label });
                    return (React.createElement("div", { "aria-label": this.props.Label, "aria-level": 1, "aria-posinset": this.props.Posinset, "aria-setsize": this.props.Setsize, className: classes, "data-dyn-selected": this.props.Selected, "data-dyn-title": this.props.Label, id: this.props.Id, onClick: this.onClick, onKeyDown: this.linkKeyDown, onMouseEnter: this.onmouseenter, ref: function (ref) { return _this.element = ref; }, role: "treeitem", tabIndex: 0 },
                        React.createElement("span", { className: "gutterPane-linkSelected" }),
                        imageContent,
                        React.createElement("a", { className: "gutterPane-linkText", "data-dyn-title": this.props.Label, onMouseEnter: this.onmouseenter }, this.props.Label)));
                };
                GutterPaneLink.prototype._setSelectedGutterItem = function (event) {
                    var target = event.target;
                    if (target.className === "gutterPane-link") {
                        this.props.SetSelectedPaneItem(Array.prototype.indexOf.call(target.parentElement.children, event.target) + 1);
                    }
                    else {
                        // target was either the image or the gutterPane-linkText, so get the index of the parent gutterPane-Link element
                        this.props.SetSelectedPaneItem(Array.prototype.indexOf.call(target.parentElement.parentElement.children, target.parentElement) + 1);
                    }
                    this.navigate({ navigationOverride: this.props.TargetMethod });
                };
                return GutterPaneLink;
            }(DynReact.Navigation));
            UI.GutterPaneLink = GutterPaneLink;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=GutterPaneLink.js.map
